// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__20KdR","buttons":"SendReceipts_buttons__naVO2","email":"SendReceipts_email__3xCqY","bookApptTitle":"SendReceipts_bookApptTitle__3eh74"};